import { css } from "styled-components";

export const copyToClipboardInputStyles = {
  inputWrapper: css`
    color: ${(p) => p.theme.colors.secondaryGrey};
    padding: 10px 12px;
    border-radius: 8px 0 0 8px;
    flex: auto;
    height: 44px;
  `,
  button: css<{ $isMobile?: boolean }>`
    height: 44px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
    padding: ${(p) => (p.$isMobile ? "4px 12px" : "4px 16px")};
  `,
};
